import type {Dispatch} from 'react';
import {createContext} from 'react';
import type {Moment} from 'moment';

import type {CleverSyncResults, CleverUser} from './util';

export interface CleverSyncState {
  loading: boolean;
  syncResults?: CleverSyncResults;
  lastSyncDate?: Moment;
  isModalOpen?: boolean;
  currentlyInProgressSyncId?: string;
}

export type CleverSyncAction =
  | {type: 'openModal'}
  | {type: 'closeModal'}
  | {type: 'setSyncDate'; date: Moment}
  | {type: 'setSyncResults'; syncResults: CleverSyncResults}
  | {type: 'setLoading'; value: boolean}
  | {type: 'setCurrentlyInProgressSyncId'; value?: string};

export const CleverSyncReducer = (
  state: CleverSyncState,
  action: CleverSyncAction
): CleverSyncState => {
  switch (action.type) {
    case 'closeModal':
      return {...state, isModalOpen: false, syncResults: undefined};

    case 'openModal':
      return {...state, isModalOpen: true};
    case 'setSyncDate':
      return {...state, lastSyncDate: action.date};
    case 'setSyncResults':
      return {...state, syncResults: action.syncResults};
    case 'setLoading':
      return {...state, loading: action.value};
    case 'setCurrentlyInProgressSyncId':
      return {...state, currentlyInProgressSyncId: action.value};
    default:
      return state;
  }
};

// Seeds reducer state from the Clever user resource's meta. Shared by every surface
// that hosts a Clever sync (home card, Create-New menu) so the seeding stays in sync.
export const initialCleverSyncState = (user: CleverUser): CleverSyncState => ({
  loading: false,
  lastSyncDate: user.getMeta().getLastCleverSyncDate(),
  currentlyInProgressSyncId: user.getMeta().getCurrentCleverSyncId()
});

export const CleverSyncContext = createContext({
  loading: false
} as CleverSyncState);
export const CleverSyncDispatch = createContext({} as Dispatch<CleverSyncAction>);
